/* oxlint-disable typescript/no-explicit-any, typescript/no-unsafe-member-access */
/* oxlint-disable require-await */
// @ts-nocheck -- removing type checking for now due to Ember Data mixin compatibility
import Model, { attr } from '@ember-data/model';
import { service, type Registry as Services } from '@ember/service';

import { authBaseURL, authUserNamespace } from 'register-partners-js/constants/hosts';
import { HTTP_STATUS_CODES } from 'register-partners-js/constants/http-status-codes';
import UserValidations from 'register-partners-js/validations/user';

const attrsToConfirmEmail = ['email', 'first_name', 'last_name', 'locale'];

export default class User extends Model.extend(UserValidations) {
  @service declare networkManager: Services['networkManager'];

  @attr('string') declare firstName: string | null;
  @attr('string') declare lastName: string | null;
  @attr('string') declare email: string | null;
  @attr('string') declare segmentId: string | null;
  @attr('string') declare phoneNumber: string | null;

  // @ts-expect-error -- not documented on openapi
  @attr zendesk;

  @attr() declare scaEnabled: boolean | null;

  @attr('string', {
    defaultValue() {
      // @ts-expect-error -- Ember model methods not fully typed
      // oxlint-disable-next-line typescript/consistent-type-assertions
      return this.get('intl.primaryLocale') as string;
    },
  })
  declare locale: string | null;

  @attr('string') declare password: string | null;
  @attr('string') declare code: string | null;

  async confirmEmail(): Promise<any> {
    const url = `${authBaseURL}/${authUserNamespace}/users/confirm`;

    // @ts-expect-error -- Ember model methods not fully typed
    // oxlint-disable-next-line typescript/no-unsafe-assignment
    const modelSerialized = this.serialize();
    const payload: Record<string, any> = {};
    // oxlint-disable-next-line no-shadow
    attrsToConfirmEmail.forEach(attr => {
      if (modelSerialized.hasOwnProperty(attr)) {
        // oxlint-disable-next-line typescript/no-unsafe-assignment
        payload[attr] = modelSerialized[attr];
      }
    });
    const data = JSON.stringify({ user: payload });

    return this.networkManager
      .request(url, {
        method: 'POST',
        body: data,
      })
      .catch((error: any) => {
        if (error.status === HTTP_STATUS_CODES.UNPROCESSABLE_ENTITY) {
          // @ts-expect-error -- Ember Data internal methods not fully typed
          this.store.recordWasInvalid(this._internalModel, error.responseJSON.errors);
        } else {
          // oxlint-disable-next-line typescript/no-unsafe-return
          return error;
        }
      });
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    user: User;
  }
}
